import React from 'react';
import RingilButton from '@components/ringil3/Buttons/RingilButton.tsx';
import SvgFolder from '@icons/folder.svg?react';
import { SecuredConfig } from '@components/security/securedDecoration';

interface ComponentProps {
  message: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
  secured?: SecuredConfig;
  dataTestId?: string;
}

const SectionEmptyState: React.FC<ComponentProps> = ({ message, buttonLabel, onButtonClick, secured, dataTestId }) => {
  return (
    <div className="flex flex-row items-center justify-center gap-4 rounded bg-white py-10" data-testid={dataTestId}>
      <SvgFolder className="w-8 h-8 opacity-40" />
      <span className="text-content-primary">{message}</span>
      {buttonLabel && onButtonClick && <RingilButton mode={'filled'} label={buttonLabel} onClick={onButtonClick} secured={secured} />}
    </div>
  );
};

export default SectionEmptyState;
